"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.appendPath = exports.useRemoveMutation = exports.useUpdateRecordMutation = exports.useUpdateColumnsMutation = exports.useUpdateColumnMutation = exports.usePatchMutation = exports.useAddMutation = exports.useFindAll = exports.useFindOne = exports.refreshList = exports.refreshOne = exports.getFindOneKey = exports.getFindAllKey = void 0;
const react_query_1 = require("react-query");
const keys_1 = __importDefault(require("./keys"));
const useAjax_1 = __importDefault(require("./hooks/useAjax"));
const url = "/";
const getFindAllKey = (resource, params) => {
    return [keys_1.default.RESOURCE_FIND_ALL, resource, params];
};
exports.getFindAllKey = getFindAllKey;
const getFindOneKey = (resource, id) => {
    return [keys_1.default.RESOURCE_FIND_ONE, resource, id];
};
exports.getFindOneKey = getFindOneKey;
function refreshOne(queryClient, resource, data) {
    return __awaiter(this, void 0, void 0, function* () {
        yield queryClient.setQueryData([keys_1.default.RESOURCE_FIND_ONE, resource, data.id], data);
    });
}
exports.refreshOne = refreshOne;
function refreshList(queryClient, resource, data, params) {
    return __awaiter(this, void 0, void 0, function* () {
        queryClient.setQueryData((0, exports.getFindAllKey)(resource, params), data);
    });
}
exports.refreshList = refreshList;
function useFindOne(resource, id, onSuccess = () => { }) {
    const enabled = id !== "";
    const ajax = (0, useAjax_1.default)();
    const path = appendPath(`${url}${resource}`, `/${id}`);
    return (0, react_query_1.useQuery)((0, exports.getFindOneKey)(resource, id), () => ajax.get(path).then((e) => e.data), {
        enabled,
        onSuccess(data) {
            onSuccess(data);
        },
    });
}
exports.useFindOne = useFindOne;
function useFindAll(resource, params) {
    const ajax = (0, useAjax_1.default)();
    const key = (0, exports.getFindAllKey)(resource, params);
    return (0, react_query_1.useQuery)(key, () => ajax.get(`${url}${resource}`, { params }).then((e) => e.data));
}
exports.useFindAll = useFindAll;
function useAddMutation(resource) {
    const ajax = (0, useAjax_1.default)();
    return (0, react_query_1.useMutation)(keys_1.default.RESOURCE_ADD, (variables) => {
        return ajax.post(`${url}${resource}`, variables).then((e) => e.data);
    });
}
exports.useAddMutation = useAddMutation;
function usePatchMutation(resource) {
    const ajax = (0, useAjax_1.default)();
    return (0, react_query_1.useMutation)(keys_1.default.RESOURCE_UPDATE_RECORD, (variables) => {
        return ajax.patch(`${url}${resource}`, variables).then((e) => e.data);
    });
}
exports.usePatchMutation = usePatchMutation;
function useUpdateColumnMutation(resource, params) {
    const ajax = (0, useAjax_1.default)();
    return (0, react_query_1.useMutation)(keys_1.default.RESOURCE_UPDATE_COLUMN, ({ id, column, value }) => {
        const path = appendPath(`${url}${resource}`, `/${id}`);
        return ajax
            .put(path, { column, value })
            .then((e) => e.data);
    });
}
exports.useUpdateColumnMutation = useUpdateColumnMutation;
function useUpdateColumnsMutation(resource, resourceName) {
    const ajax = (0, useAjax_1.default)();
    return (0, react_query_1.useMutation)(keys_1.default.RESOURCE_UPDATE_COLUMNS, ({ id, values }) => {
        let ajaxUrl = appendPath(`${url}${resource}`, "/" + id);
        if (resourceName !== undefined) {
            ajaxUrl = appendPath(ajaxUrl, `/${resourceName}`);
        }
        return ajax.patch(ajaxUrl, values).then((e) => e.data);
    });
}
exports.useUpdateColumnsMutation = useUpdateColumnsMutation;
const useUpdateRecordMutation = (resource, params) => {
    const ajax = (0, useAjax_1.default)();
    return (0, react_query_1.useMutation)(keys_1.default.RESOURCE_UPDATE_RECORD, (record) => {
        const path = appendPath(`${url}${resource}`, `/${record.id}`);
        return ajax.put(path, record).then((e) => e.data);
    });
};
exports.useUpdateRecordMutation = useUpdateRecordMutation;
const useRemoveMutation = (resource, params) => {
    const ajax = (0, useAjax_1.default)();
    return (0, react_query_1.useMutation)(keys_1.default.RESOURCE_REMOVE, ({ id }) => {
        const path = `${appendPath(`${url}${resource}`, `/${id}`)}`;
        return ajax.delete(path, { params }).then((e) => e.data);
    });
};
exports.useRemoveMutation = useRemoveMutation;
function appendPath(str, path) {
    if (str === "")
        return path;
    const queryIndex = str.lastIndexOf("?");
    if (queryIndex === -1) {
        return `${str}${path}`;
    }
    else {
        const query = str.substring(queryIndex, str.length);
        return `${str.substring(0, queryIndex)}${path}${query}`;
    }
}
exports.appendPath = appendPath;
//# sourceMappingURL=koden-crud.js.map